<script>
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";
import IconSearch from "@js/components/Icons/IconSearch.vue";
import IconX from '@js/components/Icons/IconX.vue';
import IconQuestion from "@js/components/Icons/IconQuestion.vue";

export default {
    name: "CatalogFilterBlock",
    components: {
        IconQuestion,
        IconSearch,
        IconChevronDown,
        IconX,
    },
    props: {
        title: String,
        description: String,
        default_open: {
            type: Boolean,
            default: true
        },
        enableSearch: {
            type: Boolean,
            default: false
        },
        searchPlaceholder: {
            type: String,
            default: 'Поиск по списку'
        }
    },
    data() {
        return {
            is_open: this.default_open,
            tooltipId: 'tooltip-' + Math.random().toString(36).substr(2, 9),
            tooltipVisible: false,
            searchQuery: ''
        };
    },
    mounted() {
        // Закрытие тултипа при клике вне его
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        toggleOpen() {
            this.is_open = !this.is_open;
        },
        toggleTooltip() {
            this.tooltipVisible = !this.tooltipVisible;
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.tooltipVisible = false;
            }
        }
    }
}
</script>

<template>
    <div class="w-full border-b border-gray-200 pt-4 pb-2 transition" :class="{ 'pb-0': !is_open, 'pb-5': is_open }">
        <div class="flex items-center justify-between font-medium cursor-pointer mb-2" @click.prevent="toggleOpen">
            <div class="flex items-center gap-1">
                <div>{{ title }}</div>
                <div v-if="description" class="flex items-center relative" @click.stop="toggleTooltip">
                    <button type="button" class="text-gray-500 font-bold cursor-pointer text-lg leading-none">
                        <IconQuestion class="w-4 h-4"/>
                    </button>
                    <div v-if="tooltipVisible" :id="tooltipId" role="tooltip"
                         class="w-64 absolute top-full left-0 mt-2 z-10 inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-[#3a4250] rounded-lg shadow-xs">
                        {{ description }}
                    </div>
                </div>
            </div>
            <IconChevronDown :rotate="is_open" class="w-4 h-4 text-gray-800 transition"/>
        </div>

        <div v-if="is_open && enableSearch" class="mb-2">
            <div class="group relative">
                <input v-model="searchQuery" type="text" :placeholder="searchPlaceholder"
                       class="w-full border border-gray-200 rounded-lg pl-10 pr-10 py-2 md:text-sm
                              focus:outline-none focus:ring-1 focus:ring-baseColor focus:border-baseColor
                              transition md:group-hover:border-gray-400 focus:group-hover:border-baseColor"/>
                <IconSearch class="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"/>
                <IconX v-if="searchQuery.length"
                       @click="searchQuery = ''"
                       class="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 hover:text-gray-700 cursor-pointer transition"/>
            </div>
        </div>

        <div class="h-full overflow-x-hidden overflow-y-scroll transition-all custom-scroll pe-1"
             :class="{ 'max-h-[0px]': !is_open, 'max-h-[250px]': is_open }">
            <slot :search-query="searchQuery"/>
        </div>
    </div>
</template>

<style scoped lang="scss">
.custom-scroll::-webkit-scrollbar {
    width: 16px;
}

.custom-scroll::-webkit-scrollbar-track {
    border-radius: 8px;
}

.custom-scroll::-webkit-scrollbar-thumb {
    height: 56px;
    border-radius: 8px;
    border: 5px solid transparent;
    background-clip: content-box;
    background-color: #7f7f7f;
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
    background-color: #555;
}
</style>
